<template>
  <v-theme-provider dark>
    <base-section
      id="contact-us"
      class="primary"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              :title="$t('sections.contactus.title')"
            />

            <base-body space="0">
              <span class="white--text">
                {{ $t('sections.contactus.body.text') }}
              </span>
            </base-body>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <base-btn
              color="white"
              large
              outlined
            >
              <router-link
                :block="$vuetify.breakpoint.smAndDown"
                to="/contact-us"
                style="color: white; text-decoration: none;"
                large
                outlined
              >
                {{ $t('sections.contactus.btn') }}
              </router-link>
            </base-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionContactUs',
  }
</script>
